import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class UnitsSettingsService {
  constructor(private http: HttpClient) {}

  public fetchUnitsSettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_UNITS`
    return this.http.get(url, {})
  }

  public updateUnitsSettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_UNITS`
    return this.http.put(url, payload)
  }
}
